import gql from "graphql-tag";

export const GET_TEMPLATE_COSTUME_TYPES = gql`
  query GetTemplateCostumeTypes {
    getTemplateCostumeTypes {
      content {
        id
        name
        code
        description
      }
    }
  }
`;
